import mitt from 'mitt';
import { App } from 'vue';

export default {
    install: (app: App) => {
        app.config.globalProperties.$eventBus = mitt();
    } 
};
